module.exports = __webpack_public_path__ + "static/media/pedidos-abertos-estado-vazio.027aa2f1.png";